import React from 'react';

export default function ImgDetailModal(props){

  return (
    <>
      <div className='modal-box'>
        <div className='inner'>
          <div className='modal-head'>
            <i/>
            <h4>Image Detail</h4>
          </div>
          <div className='modal-content'>
            <div className="img-box">
              {/* 이미지 호출 */}
              <img src={props?.props.data.item.img} alt="img detail" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
